<template>
    <div v-if="state === 'loading'" aria-busy="true" aria-live="polite">
        <div class="mc-skeleton" style="height: 20px; width: 40%" />
        <div class="mc-skeleton" :style="{ height: height + 'px', marginTop: '16px' }" />
        <span class="mc-sr">Caricamento in corso</span>
    </div>
    <div v-else :class="['mc-state', { 'mc-state--error': state === 'error' }]" :role="state === 'error' ? 'alert' : null">
        <svg v-if="state === 'error'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v6M12 16.5h.01" /></svg>
        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3v18h18" /><path d="M7 15h2M11 11h2M15 7h2" /></svg>
        <span class="mc-state__title">{{ title }}</span>
        <span v-if="text">{{ text }}</span>
        <button v-if="state === 'error'" class="mc-btn mc-btn--secondary" type="button" @click="$emit('retry')">Riprova</button>
    </div>
</template>
<script>
// Caricamento (skeleton con la forma del contenuto), vuoto con il perché, errore con Riprova.
export default {
    name: "McStateMessage",
    props: {
        state: { type: String, required: true, validator: (v) => ["loading", "empty", "error"].includes(v) },
        title: { type: String, default: "" },
        text: { type: String, default: "" },
        height: { type: Number, default: 160 },
    },
};
</script>
